import './pdfPolyfill';
import type { ReactElement } from 'react';
import { pdf } from '@react-pdf/renderer';
import type { DocumentProps } from '@react-pdf/renderer';
import { PDFDocument } from 'pdf-lib';

async function appendAttachment(docBytes: Uint8Array, attachmentBytes: Uint8Array): Promise<Blob> {
    const mergedDoc = await PDFDocument.create();
    const doc = await PDFDocument.load(docBytes);
    const attachmentDoc = await PDFDocument.load(attachmentBytes);

    const docPages = await mergedDoc.copyPages(doc, doc.getPageIndices());
    docPages.forEach((page) => mergedDoc.addPage(page));

    const attachmentPages = await mergedDoc.copyPages(
        attachmentDoc,
        attachmentDoc.getPageIndices()
    );
    attachmentPages.forEach((page) => mergedDoc.addPage(page));

    const mergedBytes = await mergedDoc.save();
    return new Blob([mergedBytes.buffer as ArrayBuffer], { type: 'application/pdf' });
}

/** Appends the manufacturer PDF, given as a fresh upload (`attachment`) or as the
 *  fetched bytes of one stored earlier. */
export async function renderPdfWithAttachment(
    document: ReactElement<DocumentProps>,
    attachment: File | null,
    attachmentBytes?: Uint8Array | null
): Promise<Blob> {
    const blob = await pdf(document).toBlob();
    const docBytes = new Uint8Array(await blob.arrayBuffer());
    if (attachment) {
        return appendAttachment(docBytes, new Uint8Array(await attachment.arrayBuffer()));
    }
    if (attachmentBytes) {
        return appendAttachment(docBytes, attachmentBytes);
    }
    return new Blob([docBytes.buffer as ArrayBuffer], { type: 'application/pdf' });
}
